module.exports = __webpack_public_path__ + "static/media/landing.0ec26478.jpg";